.rail {
  /* Wider than the page's container, like the logo marquee: the rail is meant to run
     past the text column and off both edges. */
  width: min(96vw, 140rem);
  margin-inline: calc(50% - min(48vw, 70rem));
}
.viewport {
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scrollbar-width: none;
  cursor: grab;
  /* The rail has no start and no end — it loops — so both edges fade out instead of
     stopping on a cut line, the same treatment the logo marquee uses. */
  mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent);
}
.viewport::-webkit-scrollbar {
  display: none;
}
.viewport[data-dragging] {
  cursor: grabbing;
  user-select: none;
}
.viewport:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 4px;
  border-radius: var(--radius-lg);
}
.track {
  display: flex;
  align-items: stretch;
  gap: var(--sp-5);
  padding-block: var(--sp-1);
  list-style: none;
}
.slide {
  flex: 0 0 clamp(17rem, 24vw, 23rem);
  display: flex;
}
.slide > * {
  flex: 1;
}
.slideWide {
  flex-basis: clamp(17rem, 46vw, 44rem);
}
.slide img {
  -webkit-user-drag: none;
  user-select: none;
}
.controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  margin-top: var(--sp-6);
}
.arrows {
  display: flex;
  gap: var(--sp-3);
}
.more {
  color: var(--link);
  text-underline-offset: 3px;
}
.arrow {
  display: grid;
  place-items: center;
  width: 2.75rem;
  height: 2.75rem;
  border: 1px solid var(--border);
  border-radius: 50%;
  background: var(--surface-raised);
  color: var(--text-strong);
  font-size: var(--fs-lg);
  line-height: 1;
  transition:
    border-color var(--dur) var(--ease),
    background-color var(--dur) var(--ease);
}
.arrow:hover {
  border-color: var(--accent);
  background: var(--surface-hover);
}
